export default "__VITE_PUBLIC_ASSET__a438c8fd__"